// extracted by mini-css-extract-plugin
export default {"editor":"FigmaUrlEditor_editor__LggTl","helper":"FigmaUrlEditor_helper__Zfrsx","actions":"FigmaUrlEditor_actions__3DYUu"};